import axios from 'axios';

import { parameters } from '../../constants/parameters';
import { Category } from '../../entities/category';
import { CompanyAdminStructure } from '../../entities/company-admin-structure';
import { Pagination } from '../../entities/pagination';
import * as genericApi from './generic-api';

export const companyAdminStructure = async (token: string): Promise<CompanyAdminStructure> => {
  const url = `${parameters.api.baseUrl}/categories/company-admin-structure`;

  return genericApi.one<CompanyAdminStructure>(token, url);
};

export const list = async (token: string, params?: object): Promise<{ items: Category[]; pagination: Pagination }> => {
  const url = `${parameters.api.baseUrl}/categories-crud`;

  return genericApi.list<Category>(token, url, params);
};

export const one = async (token: string, id: string): Promise<Category> => {
  const url = `${parameters.api.baseUrl}/categories-crud/${id}`;

  return genericApi.one<Category>(token, url);
};

export const create = async (token: string, data: Partial<Category>): Promise<Category | undefined> => {
  const url = `${parameters.api.baseUrl}/categories-crud`;

  return genericApi.create<Partial<Category>, Category>(token, url, data);
};

export const update = async (token: string, id: number, data: Partial<Category>): Promise<Category | undefined> => {
  const url = `${parameters.api.baseUrl}/categories-crud/${id}`;

  return genericApi.update<Partial<Category>, Category>(token, url, data);
};

export const remove = async (token: string, id: number): Promise<{ status: string }> => {
  const url = `${parameters.api.baseUrl}/categories-crud/${id}`;
  const response = await axios.delete(url, { headers: { Authorization: `Bearer ${token}` } });

  return response.data;
};
